
import Gallery from './components/Gallery.vue';
import Nav from './components/Nav.vue';

import {createApp} from 'vue';
import mitt from 'mitt';

const emitter = mitt();
const app = createApp({});
app.config.globalProperties.emitter = emitter;

app.component('Gallery', Gallery);
app.component('Navigation', Nav);
app.mount("#app");
